import {
  DETAIL_COURIER,
  GET_COURIER, POST_COURIER,
} from '../actionTypes';

const initialState = {
  couriers: [],
  isLoading: false,
  error: false,
  message: '',
  newCourier: false,
  totalPage: 1,
  currentPage: 1,
  totalData: 0,
  selectedCourier: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_COURIER}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_COURIER}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_COURIER}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        couriers: payload.data.data.data,
        totalData: payload.data.data?.total,
        currentPage: payload.data.data?.current_page,
        totalPage: payload.data.data?.total_page,
      };

    case `${DETAIL_COURIER}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${DETAIL_COURIER}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${DETAIL_COURIER}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedCourier: payload.data.data,
      };

    case `${POST_COURIER}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newCourier: false,
      };
    case `${POST_COURIER}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data || payload?.response?.message,
        error: true,
      };
    case `${POST_COURIER}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newCourier: true,
      };

    default:
      return state;
  }
}
